export default "__VITE_ASSET__C5J9OuyF__"